import React from 'react'
import { filter, get, map, sortBy } from 'lodash'
import { useNavigate } from "react-router-dom"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Pagination } from 'swiper'
import "swiper/css"
import "swiper/css/autoplay"
import "swiper/css/pagination"


export default({data, clinic}) => {
  const slides = filter(data, (d) => {
    if (!clinic) return !d.clinic

    return d.clinic === clinic?.url
  })

  return (
    <div className="splash-carousel">
      <div className="mb-8 max-w-6xl h-[300px] md:h-[400px] lg:h-[500px] relative mx-auto">
        <Swiper
          modules={[Autoplay, Pagination]}
          pagination={{clickable: true}}
          className="mySwiper"
          autoplay={{delay: 13000}}
          loop={true}
          speed={1000}
          watchOverflow={true}
        >
          {
            map(slides, (d, ndx) => {
              return (
                <SwiperSlide key={`splash-carousel-${ndx}`}>
                  <div className="hidden md:block bg-white bg-cover bg-no-repeat bg-center w-full h-[300px] md:h-[400px] lg:h-[500px]" style={{backgroundImage: `url('${get(d, 'image.url')}')`}}>
                    {/* <div className="max-w-6xl mx-auto px-4 pb-8 h-[300px] md:h-[400px] lg:h-[500px]">
                      {d.title}
                    </div> */}
                  </div>
                  <div  className="block md:hidden bg-white bg-cover bg-no-repeat bg-center w-full h-[300px] md:h-[400px] lg:h-[500px]" style={{backgroundImage: `url('${get(d, 'imageMobile.url')}')`}}>
                    {/* <div className="max-w-6xl mx-auto px-4 pb-8 h-[300px] md:h-[400px] lg:h-[500px]">
                      {d.title}
                    </div> */}
                  </div>
                </SwiperSlide>
              )
            })
          }
          </Swiper>
      </div>
    </div>
  )
}